import { Button, CopyToClipboard, DialogHandler, Icon, Link, TCopyToClipboard, Typography } from "@cakemail-org/ui-components-v2"
import { Stack } from "@mui/material"
import { useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { TResourceCopy } from "./types"
import "./styles.scss"
import classNames from "classnames"

export function ResourceCopy({ text, isCodeBlock = false }: TResourceCopy) {
    const { t } = useTranslation()
    const copyToClipboardRef = useRef<TCopyToClipboard>(null)
    const [viewMore, setViewMore] = useState(false)

    function handleCopy() {
        copyToClipboardRef.current?.copy(text)
        DialogHandler.show({ title: t("copied-clipboard") })
    }

    function handleToggleViewMore() {
        setViewMore(!viewMore)
    }

    let typoClasses = classNames({
        "multilineEllipsis": isCodeBlock && !viewMore,
        "ellipsis": !isCodeBlock && !viewMore
    })

    return <Stack direction="row" gap={2} alignItems={isCodeBlock ? "flex-start" : "center"} className={`resourceCopy-component ${isCodeBlock ? "codeBlock" : ""}`}>
        <CopyToClipboard ref={copyToClipboardRef} />
        <Stack overflow="hidden" gap={2}>
            <Typography variant="body1" className={typoClasses}>{text}</Typography>

            {isCodeBlock &&
                <Link onClick={handleToggleViewMore} color="body1.main">
                    {viewMore ? t("general-show-less") : t("general-show-more")}
                </Link>
            }
        </Stack>
        <Button className="copyIcon" color="body1" variant='text' onClick={handleCopy}>
            <Icon name="Copy18" />
        </Button>
    </Stack>
}